import React from 'react';
import PropTypes from 'prop-types';

import {
  TableContainer,
  HeaderCell,
  ContentCell,
  SubText,
} from './styles';

export const propTypes = {
  data: PropTypes.shape({
    headers: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        alignRight: PropTypes.bool,
        width: PropTypes.number,
      }),
    ),
    rows: PropTypes.arrayOf(
      PropTypes.arrayOf(
        PropTypes.shape({
          text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          subText: PropTypes.string,
          alignRight: PropTypes.bool,
        }),
      ),
    ),
  }),
};

const renderHeaderCell = ({
  text, alignRight, width, superscript,
}, i) => (
  <HeaderCell key={i} width={width} alignRight={alignRight}>
    {text}
    {superscript && <sup>{superscript}</sup>}
  </HeaderCell>
);

const renderContentCell = (row, i) => (
  <tr key={i}>
    {row.map(({
      text, alignRight, subText, superscript,
    }, i) => (
      <ContentCell key={i} alignRight={alignRight}>
        {text}
        {superscript && <sup>{superscript}</sup>}
        {!!subText && (
        <SubText>
          {subText}
        </SubText>
        )}
      </ContentCell>
    ))}
  </tr>
);

const Table = ({ data, evenly }) => (
  <TableContainer evenly>
    <thead>
      <tr>
        {data.headers.map(renderHeaderCell)}
      </tr>
    </thead>
    <tbody>
      {data.rows.map(renderContentCell)}
    </tbody>
  </TableContainer>
);

Table.propTypes = {
  ...propTypes,
};

export default Table;
